// extracted by mini-css-extract-plugin
module.exports = {"addPandAButtonStyle":"pAndAButton_addPandAButtonStyle__mK0JH"};